
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PaymentHeader = () => {
  const navigate = useNavigate();

  return (
    <>
      <button onClick={() => navigate(-1)} className="flex items-center text-gray-600 hover:text-gray-800 mb-8">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back
      </button>

      <div className="text-center space-y-2">
        <h1 className="text-3xl font-bold text-gray-800">Subscribe now to METRADE Premium</h1>
        <p className="text-gray-600">
          Complete your payment and start following premium strategies today!
        </p>
      </div>
    </>
  );
};

export default PaymentHeader;
